"use client";
import React from "react";
import { useIntl } from "react-intl";
import FeatureCard from "./FeatureCard";
import { useRecState } from "../../Orchestrator/Recoils/Events/Recoil";
import { ICmsEnhancedTrips } from "../../Orchestrator/Types/Interface/ICmsEnhancedTrip";
import { _eventBus } from "../../core/events/EventBus";
import { evtTree } from "../../Orchestrator/ConstantTree";
import { rememberBackPath, BACK_PATH_KEYS } from "../../Lib/Utils/backNavigation";
import CommonCardSlider from "../CommonCardSlider/CommonCardSlider";

const EnhanceYourTrip: React.FC = () => {
  const intl = useIntl();

  const [enhancedTrips] = useRecState<ICmsEnhancedTrips[]>("enhancedTripsResponseAtom");
  const onCardClick = (slug: string) => {
    if (slug && slug != "") {
      rememberBackPath(BACK_PATH_KEYS.enhancedTrips);
      _eventBus.emit({
        eventName: evtTree.enhancedTrips.Details.Click,
        data: { slug }
      });
    }
  }

  const features = enhancedTrips.filter((feature) => feature?.image?.url);

  return (
    <div className="enhance_main">
      <CommonCardSlider
        title={intl.formatMessage({ id: "EnhanceYourTrip" })}
        subTitle={intl.formatMessage({ id: "EnhanceYourTripLoverCase" })}
        items={features}
        slidesPerPage={4}
        noRecordText={intl.formatMessage({ id: "noData" })}
        getKey={(feature, index) => feature.slug || index}
        renderItem={(feature) => (
          <div
            className="text-center cursor-pointer h-100"
            onClick={() => { onCardClick(feature.slug) }}
          >
            <FeatureCard imageSrc={feature.image.url} title={feature.title} />
          </div>
        )}
      />
    </div>
  );
};

export default EnhanceYourTrip;
